"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.createOnPropertyValueSetChange = createOnPropertyValueSetChange;
exports.createOnQuantityChange = createOnQuantityChange;
const property_1 = require("@genesys/property");
const QuantityConversion = __importStar(require("@genesys/shared/lib/quantity-conversion"));
function createOnPropertyValueSetChange(outerOnChange, originalProductPropertiesMap) {
    return (properties, changedProperties) => {
        const propertiesConvertedToOriginalQuanitities = checkSelectedPropertiesForConvertedQuantities(originalProductPropertiesMap, properties);
        outerOnChange(propertiesConvertedToOriginalQuanitities, changedProperties);
    };
}
function createOnQuantityChange(onPropertyFormatChanged, measureSystem, quantityDefaults) {
    return (propertyName, quantity) => {
        // Take the default unit. The user have to change to the desired unit in the new quantity.
        const quantityDefault = QuantityConversion.getQuantityDefault(quantityDefaults, measureSystem, quantity);
        onPropertyFormatChanged(propertyName, quantityDefault.unit, quantityDefault.decimalCount);
    };
}
function checkSelectedPropertiesForConvertedQuantities(originalProductPropertiesMap, selectedProperties) {
    return property_1.PropertyValueSet.getPropertyNames(selectedProperties).reduce((soFar, propertyName) => {
        const amount = property_1.PropertyValueSet.getAmount(propertyName, selectedProperties);
        if (!amount) {
            return soFar;
        }
        const originalProductProperty = originalProductPropertiesMap.get(propertyName);
        if (!originalProductProperty) {
            return soFar;
        }
        const originalQuantity = originalProductProperty.quantity;
        if (originalQuantity === amount.unit.quantity) {
            return soFar;
        }
        const convertedAmount = QuantityConversion.convertQuantity(amount, originalQuantity, originalProductProperty.conversionParameters);
        return property_1.PropertyValueSet.setAmount(propertyName, convertedAmount, soFar);
    }, selectedProperties);
}
//# sourceMappingURL=quantity-conversion.js.map